/**
 * FeedStack
 * Container for the bottom-up feed of steps/messages
 * Steps stack upward as they are completed
 */

import React, { useRef, useEffect } from 'react';

export default function FeedStack({ children }) {
  const containerRef = useRef(null);

  // Auto-scroll to bottom when new items are added
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [children]);

  return (
    <div 
      ref={containerRef}
      className="flex-1 overflow-y-auto px-4 md:px-8 lg:px-16"
      data-testid="feed-stack"
    >
      <div className="max-w-3xl mx-auto py-8 space-y-4 flex flex-col">
        {children}
      </div>
    </div>
  );
}
